import classNames from 'classnames'
import React from 'react'
import style from './styles/errors_block.module.scss'


export const ErrorsBlock = ({
  errors,
  networkError = false,
  className = ''
}) => {
  const isArray = Array.isArray(errors) && errors !== undefined && errors.length > 0

  if (errors === undefined) {
    return null
  }

  return (
    <div
      className={classNames({
        [style.errors]: true,
        [className]: Boolean(className)
      })}
    >
      {!isArray
        ? (
          <span className={style.errors__text}>
            {errors}
          </span>
          )
        : null}

      {isArray
        ? errors.map((el) => {
          return (
            <span className={style.errors__text} key={el}>
              {el}
            </span>
          )
        })
        : null}

      {networkError === true
        ? (
          <span className={style.errors__text}>
            Network error
          </span>
          )
        : null}

    </div>
  )
}

export default ErrorsBlock
